import {asMutable} from "seamless-immutable";

export const validateFormErrorResponse = (error) => {
	if (typeof error === 'string') {
		return error;
	} else if (typeof error === 'object') {
		const errorObject = [];
		const objectKeys = Object.keys(error);
		// console.log(objectKeys);
		objectKeys.map((k) => {
			errorObject.push({
				field: k,
				error: error[k][0]
			});
		});
		return errorObject;
	}
	return error;
};

export const getRandomID = () => {
	return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
};

export const isValidURL = (str) => {
	var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
		'(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
	return !!pattern.test(str);
};

export const isMediaAlreadyFavorited = (favorites, media) => {
	// console.log(favorites, media);
	if (typeof favorites !== 'undefined' && favorites !== null && favorites.length > 0) {
		if (typeof media !== 'undefined' && media !== null) {
			const mediaInFavoritesIndex = favorites.findIndex((el) => {
				return el.favourite_id === media.id;
			});
			if (mediaInFavoritesIndex > -1) {
				return true;
			} else {
				return false;
			}
		}
	}
	return false;
};


export const isMediaViewed = (media) => {
	if (media.hasOwnProperty('is_viewed')) {
		return media.is_viewed;
	} else {
		return false;
	}
};

export const isAnswerCorrect = (question, answer) => {
	const answerIndex = question.question_options.findIndex((el) => {
		return el.id === answer;
	});
	if (answerIndex > -1) {
		if (question.question_options[answerIndex].is_accepted) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
};

export const isIOSDevice = () => {
	const ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
	// console.log('device is ios: ', ios);
	return ios;
};

export const getValidPhone = (phone) => {
	return '+2' + phone;
};

export const isMobile = () => {
	let check = false;
	if (typeof window !== 'undefined') {
		(function (a) {
			if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
		})(navigator.userAgent || navigator.vendor || window.opera);
	}
	return check;
};

export const timeDiff = (start, end) => {
	return 5555;
};

export const sortQuestions = (questions, phase = 'LISTENING', interventionType) => {
	console.log(questions);
	const sortedQuestions = [];
	let learningPhase = 'Listening';
	if (phase && phase.toUpperCase() === 'READING') {
		learningPhase = 'Reading';
	} else {
		learningPhase = 'Listening';
	}
	let learningActivityType = 'intervention';
	if (interventionType.toUpperCase() === 'ASSESSMENT') {
		learningActivityType = 'test';
	} else {
		learningActivityType = 'intervention';
	}
	const phaseQuestions = questions[learningPhase];
	const questionTypes = ['Nouns', 'Verbs', 'Adjectives', 'Concepts', 'Pronouns', 'Phrase', 'Sentences', 'Short Paragraph', 'Longer Paragraph'];
	questionTypes.map((type) => {
		phaseQuestions[type].map((el, index) => {
			if (interventionType === 'INTERVENTION') {
				learningPhase = (index + 1) % 2 === 0 ? 'Reading' : 'Listening';
			}
			if (el[learningActivityType]) {
				sortedQuestions.push({
					...el,
					acquired: false,
					attempts: 0,
					type: type,
					phase: learningPhase,
				});
			}
			if (sortedQuestions[type]) {
				if (sortedQuestions[type].length > 15) {
					console.log(type);
				}
			}
		});
	});
	return sortedQuestions;
};

export const shuffleAnswersArray = (images) => {
	let currentIndex = images.length, temporaryValue, randomIndex;
	
	// While there remain elements to shuffle...
	while (currentIndex !== 0) {
		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex)
		currentIndex -= 1;
		
		// And swap it with the current element.
		temporaryValue = images[currentIndex];
		images[currentIndex] = images[randomIndex];
		images[randomIndex] = temporaryValue;
	}
	
	return images;
};

export const getID = () => {
	return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
};

export const appreciationText = [
	// 'That\'s right',
	// 'Way to go',
	'Well done',
];

export const getRandom = (myArray) => {
	return myArray[Math.floor(Math.random() * myArray.length)];
};

export const sortInterventionQuestions = (questions) => {
	// console.log('\n sort questions \n', questions);
	const sortedListeningQuestions = [];
	const sortedReadingQuestions = [];
	const questionsData = questions;
	console.log('\n phaseQuestions \n', questionsData);
	let learningPhase = 'Listening';
	let phaseQuestions = questionsData[learningPhase];
	console.log('\n phaseQuestions \n', phaseQuestions);
	const questionTypes = getQuestionTypesArray(questions.stats, phaseQuestions);
	console.log('\n questionTypes \n', questionTypes);
	questionTypes.map((type) => {
		if (typeof phaseQuestions[type] !== 'undefined' && phaseQuestions[type].length > 0) {
			let questionsArray = phaseQuestions[type];
			// console.log('questionsArray: \n', questionsArray);
			questionsArray = questionsArray.filter((el) => {
				return parseInt(el.is_acquired) < 1;
			});
			// console.log(questionsArray);
			if (type.toUpperCase() === 'NOUNS') {
				//questionsArray.length = 30
				questionsArray = questionsArray.slice(31, questionsArray.length);
			} else if (type.toUpperCase() === 'VERBS') {
				//questionsArray.length = 30
				questionsArray = questionsArray.slice(31, questionsArray.length);
			} else if (type.toUpperCase() === 'PHRASE') {
				//questionsArray.length = 40
				questionsArray = questionsArray.slice(41, questionsArray.length);
			}
		// console.log('questionArray after reducing: \n', questionsArray);
			questionsArray.map((el) => {
				if (el.intervention && parseInt(el.trials) < 9 && parseInt(el.is_acquired) < 2) {
					sortedListeningQuestions.push({
						...el,
						acquired: false,
						attempts: 0,
						type: type,
						phase: parseInt(el.is_acquired) === 0 ? 'Listening' : 'Reading',
						trials: parseInt(el.trials),
						localTrials: 0,
						trialStats: {
							first: false,
							second: false,
							third: false,
						},
					});
				}
			});
		}
	});
	// learningPhase = 'Reading'
	// phaseQuestions = questionsData[learningPhase]
	// questionTypes.map((type) => {
	// 	if (phaseQuestions[type].length > 0) {
	// 		phaseQuestions[type].map((el) => {
	// 			if (el.intervention) {
	// 				sortedReadingQuestions.push({
	// 					...el,
	// 					acquired: false,
	// 					attempts: 0,
	// 					type: type,
	// 					phase: learningPhase,
	// 				})
	// 			}
	// 		})
	// 	}
	// })
	// console.log(sortedListeningQuestions, sortedReadingQuestions);
	const sortedQuestions = [sortedListeningQuestions, sortedReadingQuestions]
		.reduce((r, a) => (a.forEach((a, i) => (r[i] = r[i] || []).push(a)), r), [])
		.reduce((a, b) => a.concat(b));
	return sortedQuestions;
};

export const getQuestionTypesArray = (stats, questions) => {
	let questionsTypesArray = [];
	let objkeys = {
		Nouns: false,
		Verbs: false,
		Adjectives: false,
		Concepts: false,
		Pronouns: false,
		Phrase: false,
	};
	let {acquiredNouns, acquiredVerbs, acquiredAdjectives, acquiredConcepts, acquiredPronouns, acquiredPhrase} = false;
	// ['Nouns', 'Verbs', 'Adjectives', 'Concepts', 'Pronouns', 'Phrase', 'Sentences']
	// check for nouns
	let acquiredArr = Object.keys(stats.acquired);
	for (let i = 0; i < acquiredArr.length; i++) {
		if (Object.keys(questions).indexOf(acquiredArr[i]) !== -1) {
			if (acquiredArr[i] === 'Verbs' || acquiredArr[i] === 'Adjectives') {
				if (stats.acquired[acquiredArr[i]] < 25 || stats.acquired[acquiredArr[i]] < Math.round((80 / 100) * stats.total[acquiredArr[i]]) && stats.acquired['Nouns'] > 25) {
					questionsTypesArray.push(acquiredArr[i]);
				} else if (stats.acquired[acquiredArr[i]] >= Math.round((80 / 100) * stats.acquired[acquiredArr[i]])) {
					objkeys[acquiredArr[i]] = true;
				}
			} else {
				if (acquiredArr[i] !== 'Nouns') {
					if (stats.acquired[acquiredArr[i]] < 25 || stats.acquired[acquiredArr[i]] < Math.round((80 / 100) * stats.total[acquiredArr[i]]) && objkeys[acquiredArr[i]]) {
						questionsTypesArray.push(acquiredArr[i]);
					} else if (stats.acquired[acquiredArr[i]] >= Math.round((80 / 100) * stats.acquired[acquiredArr[i]])) {
						objkeys[acquiredArr[i]] = true;
					}
				} else {
					if (stats.acquired[acquiredArr[i]] < 25 || stats.acquired[acquiredArr[i]] < Math.round((80 / 100) * stats.total[acquiredArr[i]])) {
						questionsTypesArray.push(acquiredArr[i]);
					} else if (stats.acquired[acquiredArr[i]] >= Math.round((80 / 100) * stats.acquired[acquiredArr[i]])) {
						objkeys[acquiredArr[i]] = true;
					}
				}
			}
		}
	}

	// if (stats.acquired['Nouns'] < 25 || stats.acquired['Nouns'] < Math.round((80 / 100) * stats.total['Nouns'])) {
	// 	questionsTypesArray.push('Nouns');
	// } else if (stats.acquired['Nouns'] >= Math.round((80 / 100) * stats.total['Nouns'])) {
	// 	acquiredNouns = true;
	// }
	// // check for Verbs
	// if ((stats.acquired['Verbs'] < 25 || stats.acquired['Verbs'] < Math.round((80 / 100) * stats.total['Verbs'])) && stats.acquired['Nouns'] > 25) {
	// 	questionsTypesArray.push('Verbs');
	// } else if (stats.acquired['Verbs'] >= Math.round((80 / 100) * stats.total['Verbs'])) {
	// 	acquiredVerbs = true;
	// }
	// // check for adjectives
	// if ((stats.acquired['Adjectives'] < 25 || stats.acquired['Adjectives'] < Math.round((80 / 100) * stats.total['Adjectives'])) && stats.acquired['Nouns'] > 25) {
	// 	questionsTypesArray.push('Adjectives');
	// } else if (stats.acquired['Adjectives'] >= Math.round((80 / 100) * stats.total['Adjectives'])) {
	// 	acquiredAdjectives = true;
	// }
	// // check for Concepts
	// if ((stats.acquired['Concepts'] < Math.round((80 / 100) * stats.total['Concepts'])) && acquiredVerbs && acquiredAdjectives) {
	// 	questionsTypesArray.push('Concepts');
	// } else if (stats.acquired['Concepts'] >= Math.round((80 / 100) * stats.total['Concepts'])) {
	// 	acquiredConcepts = true;
	// }
	// // check for Pronouns
	// if (stats.acquired['Pronouns'] < stats.total['Pronouns'] && acquiredVerbs && acquiredAdjectives) {
	// 	questionsTypesArray.push('Pronouns');
	// } else {
	// 	acquiredPronouns = true;
	// }
	// // check for Phrase
	// if (stats.acquired['Phrase'] < Math.round((80 / 100) * stats.total['Phrase']) && acquiredVerbs && acquiredAdjectives && acquiredPronouns) {
	// 	questionsTypesArray.push('Phrase');
	// } else {
	// 	acquiredPhrase = true;
	// }
	// // check for Sentences
	// // if (acquiredNouns && acquiredVerbs && acquiredAdjectives && acquiredConcepts && acquiredPronouns && acquiredPhrase) {
	// 	questionsTypesArray.push('Sentences');
	// 	questionsTypesArray.push('Longer Paragraph');
	// 	questionsTypesArray.push('Short Paragraph');
	// // }
	return questionsTypesArray;
};

export const getListeningAnswers = (answers) => {
    const listeningAnswers = [];
    answers.map((ans) => {
        const el = ans;
        const existingIndex = listeningAnswers.findIndex((e) => {
            const phaseUpper = (e.phase ? String(e.phase).trim().toUpperCase() : (e.firstPhase ? 'LISTENING' : 'READING'));
            if (e.id === el.id && phaseUpper === 'LISTENING') {
                return e;
            }
        });
        const acquiredFlag = el.acquired === true || el.acquired === 1 || el.acquired === '1';
        const learnedForDisplay = acquiredFlag || (el.trialStats && (el.trialStats.first || el.trialStats.second || el.trialStats.third));
        const elPhaseUpper = (el.phase ? String(el.phase).trim().toUpperCase() : (el.firstPhase ? 'LISTENING' : 'READING'));
        if (learnedForDisplay && elPhaseUpper === 'LISTENING' && existingIndex === -1) {
            listeningAnswers.push(el);
        }
    });
    return listeningAnswers;
};

export const getReadingAnswers = (answers) => {
    const readingAnswers = [];
    answers.map((ans) => {
        const el = ans;
        const existingIndex = readingAnswers.findIndex((e) => {
            const phaseUpper = (e.phase ? String(e.phase).trim().toUpperCase() : (e.firstPhase ? 'LISTENING' : 'READING'));
            if (e.id === el.id && phaseUpper === 'READING') {
                return e;
            }
        });
        const acquiredFlag = el.acquired === true || el.acquired === 1 || el.acquired === '1';
        const learnedForDisplay = acquiredFlag || (el.trialStats && (el.trialStats.first || el.trialStats.second || el.trialStats.third));
        const elPhaseUpper = (el.phase ? String(el.phase).trim().toUpperCase() : (el.firstPhase ? 'LISTENING' : 'READING'));
        if (learnedForDisplay && elPhaseUpper === 'READING' && existingIndex === -1) {
            readingAnswers.push(el);
        }
    });
    return readingAnswers;
};

export const changeCategory = (pStats, questions, serverQuestions) => {
	let questionsData = questions;
	let questionTypes = [];
	const unfilteredQuestions = serverQuestions;
	const stats = pStats;
	const lastQuestion = questionsData[questionsData.length - 1];
	if (stats.acquired['Nouns'] > 24 && stats.acquired['Verbs'] === 0 && stats.acquired['Adjectives'] === 0) {
		if (lastQuestion.type.toUpperCase() !== 'VERBS' && lastQuestion.type.toUpperCase() !== 'ADJECTIVES') {
			questionTypes = ['Verbs', 'Adjectives'];
		}
	}
	if (stats.acquired['Verbs'] > 24 && stats.acquired['Adjectives'] > 24) {
		if (lastQuestion.type.toUpperCase() !== 'CONCEPTS') {
			questionTypes = ['Concepts'];
		}
	}
	if ((stats.acquired['Concepts'] > Math.round((80 / 100) * stats.total['Concepts']))) {
		if (lastQuestion.type.toUpperCase() !== 'PRONOUNS') {
			questionTypes = ['Pronouns'];
		}
	}
	if (stats.acquired['Pronouns'] >= stats.total['Pronouns']) {
		if (lastQuestion.type.toUpperCase() !== 'PHRASE') {
			questionTypes = ['Phrase'];
		}
	}
	if (stats.acquired['Phrase'] > Math.round((80 / 100) * stats.total['Phrase'])) {
		if (lastQuestion.type.toUpperCase() !== 'SENTENCES') {
			questionTypes = ['Sentences'];
		}
	}
	
	if (questionTypes.length > 0) {
		questionTypes.map((type) => {
			if (unfilteredQuestions['Listening'][type].length > 0) {
				unfilteredQuestions['Listening'][type].map((el) => {
					if (el.intervention && parseInt(el.trials) < 9 && parseInt(el.is_acquired) < 2) {
						questionsData.push({
							...el,
							acquired: false,
							attempts: 0,
							type: type,
							phase: parseInt(el.is_acquired) === 0 ? 'Listening' : 'Reading',
							trials: parseInt(el.trials),
							trialStats: {
								first: false,
								second: false,
								third: false,
							},
						});
					}
				});
			}
		});
	}
	return questionsData;
};

export const getInterventionQuestionImagesArray = (question) => {
	console.log(question);
	const imagesArray = [];
	const additionalImages = [
		question.distractor_image,
		question.optional_image,
		question.optional_image_2,
	];
	if (question.trials > 0 && question.other_images.length > 0 && !question.acquired) {
		// var index = question.imagesArray.indexOf(question.image);
		// if (index !== -1 && question.other_images.length > 0) {
		// 	console.log(index);
		// 	console.log(getRandom(question.other_images));
		// 	// question = {
		// 	// 	...question,
		// 	// 	image: getRandom(question.other_images).filename,
		// 	// };
		// 	// console.log(question);
		// 	imagesArray.unshift(getRandom(question.other_images).filename);
		// }
		imagesArray.unshift(getRandom(question.other_images).filename);
	} else {
		imagesArray.push(question.image);
	}
	imagesArray.push(getRandom(additionalImages));
	return imagesArray;
};

export const questionImages = (questionsData, currentIndex) => {
	const questions = questionsData;
	const question1 = questions[currentIndex + 1];
	const question2 = questions[currentIndex + 2];
	const imageUrls = [];
	if (typeof question1 !== 'undefined' && typeof question2 !== 'undefined') {
		imageUrls.push(question1.image);
		imageUrls.push(question2.image);
		imageUrls.push(question1.distractor_image);
		imageUrls.push(question2.distractor_image);
		imageUrls.push(question1.optional_image);
		imageUrls.push(question2.optional_image);
		imageUrls.push(question1.optional_image_2);
		imageUrls.push(question2.optional_image_2);
	}
	return imageUrls;
};

export const millisToMinutesAndSeconds = (millis) => {
	const minutes = Math.floor(millis / 60);
	const seconds = ((millis % 60) / 100).toFixed(0);
	return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
};

export const shuffleInterventionAnswersArray = (images) => {
	let imagesArray = asMutable(images, {deep: true});
	let currentIndex = imagesArray.length, temporaryValue, randomIndex;
	// While there remain elements to shuffle...
	while (currentIndex !== 0) {
		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;
		// And swap it with the current element.
		temporaryValue = imagesArray[currentIndex];
		imagesArray[currentIndex] = imagesArray[randomIndex];
		imagesArray[randomIndex] = temporaryValue;
	}
	return imagesArray;
};

export const shuffleCorrectAnswersArray = (optionsCorrectImages, correctImage) => {
	let correctImagesArray = [];
	// imagesArray.push(correctImage,optionsCorrectImages);
	var i;
	for (i = 0; i < optionsCorrectImages.length; i++) {
		correctImagesArray.push(optionsCorrectImages[i].filename);
		// console.log(optionsCorrectImages[i].filename);
	}
	correctImagesArray.push(correctImage);
	let imagesArray = asMutable(correctImagesArray, {deep: true});
	let currentIndex = imagesArray.length, temporaryValue, randomIndex;
	// While there remain elements to shuffle...
	while (currentIndex !== 0) {
		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;
		// And swap it with the current element.
		temporaryValue = imagesArray[currentIndex];
		imagesArray[currentIndex] = imagesArray[randomIndex];
		imagesArray[randomIndex] = temporaryValue;
	}
	return imagesArray;
};
